/* eslint-disable react/destructuring-assignment */
import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

export const CartItemsSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '676px'}
        width="100%"
        borderRadius={0}
        data-testid="cart-items-skeleton"
        {...props}
    />
);

export const TitleSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '60px'}
        width="100%"
        borderRadius={0}
        data-testid="cart-title-skeleton"
    />
);

export const FreeShippingBarSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        padding="1rem"
        background="white"
        height="94px"
        width="100%"
        data-testid="cart-free-shipping-skeleton"
        borderRadius={0}
        boxShadow="none"
    />
);

export const OrderSummarySkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '482px'}
        width="100%"
        data-testid="cart-order-summary-skeleton"
        borderRadius={props.isLoaded ? { base: 0, md: 16 } : 0}
        boxShadow={props.isLoaded ? '0px 2px 10px 0px rgba(65, 64, 66, 0.14)' : 'none'}
    />
);

export const PromoCodeSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '80px'}
        width="100%"
        data-testid="cart-promo-code-skeleton"
        borderRadius={props.isLoaded ? { base: 0, md: 16 } : 0}
        boxShadow={props.isLoaded ? '0px 2px 10px 0px rgba(65, 64, 66, 0.14)' : 'none'}
    />
);

export const SaveForLaterSkeleton: FC<SkeletonProps> = (props) => (
    <Skeleton
        {...props}
        height={props.isLoaded ? undefined : '538px'}
        width="100%"
        borderRadius={0}
        data-testid="cart-save-for-later-skeleton"
    />
);
